import { Account, ClientAccount } from '@lune-climate/lune'
import { ButtonGroupNew, ButtonNew, InputNew, Modal, Text } from '@lune-fe/lune-ui-lib'
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined'
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined'
import Box from '@mui/material/Box'
import { useSnackbar } from 'notistack'
import { FC, useState } from 'react'
import { CopyToClipboard } from 'react-copy-to-clipboard'

import useIsTestMode from 'hooks/useIsTestMode'
import { getPublicPageUrl, PublicPagesType } from 'utils'

const PublicPagesModal: FC<{
    account: ClientAccount | Account
    open: boolean
    onModalClose: () => void
}> = ({ account, open, onModalClose }) => {
    const isTestMode = useIsTestMode()
    const { enqueueSnackbar: snackbar } = useSnackbar()

    const [pageTypeSelected, setPageTypeSelected] = useState<PublicPagesType>(
        PublicPagesType.LOGISTICS,
    )

    const getPublicPageUrlForSelectedType = (): string => {
        return getPublicPageUrl(
            !!isTestMode,
            account.organisationId,
            account.handle!,
            pageTypeSelected,
        )
    }

    return (
        <Modal
            open={open}
            maxWidth={'sm'}
            fullWidth
            onClose={() => onModalClose()}
            header={
                <Text
                    variant={'h5'}
                    sx={{
                        mb: -3,
                    }}
                >
                    Customer Pages
                </Text>
            }
        >
            <Box sx={{ width: '100%' }}>
                <ButtonGroupNew
                    sx={{ width: '100%' }}
                    value={pageTypeSelected}
                    items={[
                        {
                            label: 'Logistics',
                            value: PublicPagesType.LOGISTICS,
                        },
                        {
                            label: 'Spend Management',
                            value: PublicPagesType.BUSINESS,
                        },
                        {
                            label: 'Offsets',
                            value: PublicPagesType.OFFSETS,
                        },
                    ]}
                    onChange={(type) => setPageTypeSelected(type as PublicPagesType)}
                />
                <Box
                    sx={{
                        mt: 4,
                        display: 'flex',
                        gap: 2,
                        alignItems: 'center',
                    }}
                >
                    <InputNew
                        sx={{
                            width: '100%',
                            textDecoration: 'underline',
                            input: {
                                textOverflow: 'ellipsis',
                            },
                        }}
                        startAdornment={<InsertLinkOutlinedIcon />}
                        readOnly
                        value={getPublicPageUrlForSelectedType()}
                    />

                    <CopyToClipboard
                        text={getPublicPageUrlForSelectedType()}
                        onCopy={() => snackbar(`Selection copied to the clipboard.`)}
                    >
                        <ButtonNew
                            size={'sm'}
                            sx={{ flex: '1 0 auto' }}
                            style={'floating'}
                            leadingIcon={<ContentCopyOutlinedIcon />}
                        >
                            Copy link
                        </ButtonNew>
                    </CopyToClipboard>
                </Box>
            </Box>
        </Modal>
    )
}

export default PublicPagesModal
